export const APP_ROUTES = {
    'MAIN': '/',
    'SUREBETS': '/surebets',
    'BETTING_CONTEST': '/betting-contest',
    'FIFA_RANKING': '/fifa-world-ranking',
} as const

export const DOMAIN_LANGS = ['de']